import { render, staticRenderFns } from "./PercentageBar.vue?vue&type=template&id=46979ffa&scoped=true&"
import script from "./PercentageBar.vue?vue&type=script&lang=js&"
export * from "./PercentageBar.vue?vue&type=script&lang=js&"
import style0 from "./PercentageBar.vue?vue&type=style&index=0&id=46979ffa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46979ffa",
  null
  
)

export default component.exports